<template lang="html">
  <div class="user-icon" v-on="$listeners" :class="typeof status === 'number' ? '_'+status : status">
    <img
      :src="url"
      @error="iconError = true"
      alt="User icon"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserIcon',
  props: {
    userId: String,
    userStatus: [String, Number],
    currentUser: Boolean
  },
  data: () => ({
    iconError: false
  }),
  computed: {
    ...mapGetters('api/media', ['getAvatarUrl']),
    ...mapGetters({
      currentUserId: 'current_user/id',
      currentUserStatus: 'current_user/status',
      currentUsersAvatar: 'current_user/avatar'
    }),
    currentUserComputed: vm => vm.currentUser || vm.currentUserId === vm.userId,
    status: vm => vm.userStatus || (vm.currentUserComputed ? vm.currentUserStatus : null),
    placeholder: () => require('@/assets/images/participant.png'),
    url() {
      if(this.iconError) return this.placeholder;
      else if(this.currentUserComputed) return this.currentUsersAvatar;
      else return this.userId ? this.getAvatarUrl(this.userId) : this.placeholder;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-icon {
  border: 3px solid $not-active-user;
  overflow: hidden;
  border-radius: 100%;
  background: white;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.available, &._1 {
    border-color: $active-user-room;
  }

  &.offline {
    border-color: $secondary-grey;
  }

  &.dark {
    border-color: #2C2C2C;
  }
}
</style>
